import { useEffect, useRef, useState } from "react"
import { Button, Dropdown, Tooltip, Input } from "antd"
import { DownOutlined, UpOutlined, EllipsisOutlined } from "@ant-design/icons"
import { OTHERS, DISCRIPTION, INTERNAL } from "../../utils/Constants"
import TableColumnFilter from "../common/TableColumnFilter"
import { getTableCellData } from "../../utils/SchemaParseUtils"
import UMCTable from "./UMCTable"
import { useDispatch, useSelector } from "react-redux"
import { setSortType, setSortField, setContentLoading, setpersistedSort } from "../../store/reducers/CommonReducer"
import UMCModal from "../common/UMCModal"
import { getDetailedTableData } from "../../store/actions/CommonActions"
import UMCButton from "./UMCButton"
import { getTranslated, getSortedTableData } from "../../utils/CommonUtils"

const CustomTable = (props) => {
    const dispatch = useDispatch()
    const [hoveredRow, setHoveredRow] = useState(null)
    const [selectedRows, setSelectedRows] = useState([])
    const [optionHoverIndex, setOptionHoverIndex] = useState(null)
    const [columns, setColumns] = useState([])
    const [dataSource, setDataSource] = useState([])
    const [sortOrder, setSortOrder] = useState({})
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [modalData, setModalData] = useState(null)
    const [currRowData, setCurrRowData] = useState({})

    const dict = useSelector(state => state.common.dict)
    const persistedSort = useSelector(state => state.common.persistedSort)

    const imgRef = useRef()

    
    useEffect(() => {
        getColumns()
    }, [props.schema, props.filteredData, props.tableData, props.updateTableAction, dict])

    useEffect(() => {
        getDataSource()
    }, [props.filteredData, hoveredRow, columns, optionHoverIndex, selectedRows])

    useEffect(() => { //When data reloads from API, re-apply the last sorting
        if (persistedSort[props.tabKey]?.columnId && props.tableData?.length) {
            handleSort(persistedSort[props.tabKey].columnId, persistedSort[props.tabKey].order)
        }
    }, [props.tableData, props.tabKey])

    const handleSort = (columnId, sortOrder) => {
        dispatch(setpersistedSort({
            tab: props.tabKey,
            columnId,
            order: sortOrder
        }))

        const sortedData = getSortedTableData({
            filteredData: props.filteredData,
            tableData: props.tableData,
            columnId,
            sortOrder
        })

        dispatch(props.updateTableAction(sortedData))
    }

    const handleModalClose = () => {
        setIsModalVisible(false)
    }

    const getItemList = (rowData) => {
        return [
            {
                key: 'tbl-modify',
                label: getTranslated(dict, "LABEL_MODIFY"),
                onClick: () => {
                    if (props.handleRowSelect) {
                        dispatch(setContentLoading(true))
                        props.handleRowSelect(rowData)
                    }
                }
            },
            {
                key: 'tbl-delete',
                label: getTranslated(dict, "LABEL_DELETE"),
                danger: true,
                onClick: () => {
                    props.handleRowDelete && props.handleRowDelete(rowData?.key)
                }
            },
        ]
    }


    const getOnHoverItemList = (rowId) => {
        return [
            {
                key: 'tbl-modify',
                label: getTranslated(dict, "LABEL_ACTIVE_LICENCE_BUSINESS"),
                disabled: true,
                // onClick: () => {
                //     dispatch(setContentLoading(true))
                //     props.handleRowSelect && props.handleRowSelect(rowId)
                // }
            },
            {
                key: 'tbl-delete',
                label: getTranslated(dict, "LABEL_ACTIVE_LICENSE_HOTEL"),
                disabled: true,
                // onClick: () => {
                //     props.handleRowDelete && props.handleRowSelect(rowId)
                // }
            },
        ]
    }

    const toggleSortOrder = (columnId) => {
        const newOrder = sortOrder[columnId] === "ASC" ? "DESC" : "ASC"
        setSortOrder({ [columnId]: newOrder })

        return newOrder
    }

    const getColumns = () => {
        let tempColumns = []

        props.schema.forEach((attribute, index) => {

            if (attribute.access !== INTERNAL) { // Check it seperately
                tempColumns.push({
                    ...attribute,
                    title: (currentPageData) => {
                        const sortedColumn = currentPageData?.sortColumns?.find(({ column }) => column.key === attribute.id)
                        const isAscending = sortOrder[attribute.id] === "ASC"
                        const tooltipText = isAscending ? getTranslated(dict, "LABEL_CLICK_SORT_DESC") : getTranslated(dict, "LABEL_CLICK_SORT_ACS")

                        return <>
                            {
                                props.isDynamicAction ? (
                                    attribute.isSortable !== false ? (
                                        <Tooltip title={tooltipText}>
                                            <div className="tbl-td-label">
                                                {getTranslated(dict, attribute.label)?.toUpperCase()}
                                                {isAscending ? (
                                                    <UpOutlined style={{ float: "right" }} />
                                                ) : (
                                                    <DownOutlined style={{ float: "right" }} />
                                                )}
                                            </div>
                                        </Tooltip>
                                    ) : (
                                        <div className="tbl-td-label">
                                            {getTranslated(dict, attribute.label)?.toUpperCase()}
                                        </div>
                                    )
                                ) : (
                                    <div className="tbl-td-label">
                                        {getTranslated(dict, attribute.label)?.toUpperCase()}
                                        {attribute.isSortable !== false && (() => {
                                            let activeSort = null;

                                            // Check if there is persistedSort
                                            if (persistedSort[props.tabKey] && persistedSort[props.tabKey].columnId === attribute.id) {
                                                activeSort = persistedSort[props.tabKey].order === "ASC" ? "ascend" : "descend"
                                            }

                                            // Fallback to AntD
                                            if (!activeSort && sortedColumn?.order) {
                                                activeSort = sortedColumn.order
                                            }

                                            // Choose icon
                                            return activeSort === "ascend"
                                                ? <UpOutlined style={{ float: "right" }} />
                                                : <DownOutlined style={{ float: "right" }} />
                                        })()}
                                    </div>
                                )}

                            {attribute.filterType !== "NONE" ? <TableColumnFilter
                                colId={attribute.id}
                                filterType={attribute.filterType}
                                enum={attribute.enum}
                                updateTableAction={props.updateTableAction}
                                filteredData={props.filteredData}
                                tableData={props.tableData}
                                isDynamicAction={props.isDynamicAction}
                                fetchData={props.fetchData}
                            /> :
                                <Input
                                    style={{ visibility: "hidden" }}
                                    className="tbl-col-search"
                                />}
                            {/* </div>  */}
                        </>
                    },
                    dataIndex: attribute.id,
                    key: attribute.id,
                    width: attribute.width,
                    ...(attribute.id === OTHERS && {
                        onCell: () => ({
                            onClick: (event) => event.stopPropagation(), // Stops event propagation to the row for OTHERS column
                        })
                    }),
                    ...(attribute.isSortable === false
                        ? {}
                        : props.isDynamicAction
                            ? {
                                // Dynamic Tables
                                onHeaderCell: () => ({
                                    onClick: () => {
                                        const newOrder = toggleSortOrder(attribute.id)
                                        dispatch(setSortType(newOrder))
                                        dispatch(setSortField(attribute.id))
                                        dispatch(props.fetchData())
                                    },
                                    className: "sortable-header"
                                })
                            }
                            : {
                                // static Tables
                                onHeaderCell: () => ({
                                    onClick: () => {
                                        const newOrder = toggleSortOrder(attribute.id)
                                        handleSort(attribute.id, newOrder)
                                    }
                                }),
                                sortDirections: ["ascend", "descend", "ascend"],
                                sorter: true
                    }),
                })
            }
        })

        setColumns(tempColumns)
    }

    const generateCustomRowData = (value) => {
        let { rowData, item, index } = value
        const rowHovered = hoveredRow === rowData.key || selectedRows.includes(rowData.key)
        // const iconHovered = optionHoverIndex === index ? false : rowHovered
        const isOthersActive = rowHovered || optionHoverIndex === index;

        columns.forEach(col => {
            rowData = {
                ...rowData,
                [col.dataIndex]: (() => {
                    if (col.dataIndex === DISCRIPTION) {
                        if (rowData.attribute.isDetailedInfoExist === "true") {
                            return (
                                <div
                                    className="ellipsis-container"
                                    onClick={() => {
                                        dispatch(setContentLoading(true))
                                        dispatch(getDetailedTableData(`${props.detailedDataAPI}/${rowData.id}`, (data) => {
                                            setCurrRowData({
                                                id: rowData.id,
                                                time: rowData.timestamp.props.children
                                            })
                                            setModalData(data)
                                        }))
                                        setIsModalVisible(true)
                                    }}
                                >
                                    {item.attribute.description}
                                    <EllipsisOutlined className="rotated-ellipsis" />
                                </div>
                            )
                        }
                        return <>{item.attribute.description}</>
                    }

                    if (col.dataIndex === OTHERS) {
                        return (item.modifiable === undefined || item.modifiable) ? (
                            <span>
                                <Dropdown
                                    menu={{ items: getItemList(rowData, dispatch, props) }}
                                    trigger={['click']}
                                    onOpenChange={(open) => {
                                        if (props.bulk) {
                                            (selectedRows.length !== 1 || !selectedRows.some(row => row === item.id)) && setSelectedRows([])
                                        }
                                        setOptionHoverIndex(open ? index : null)
                                    }}
                                >
                                    <Button className="tbl-other-btn" ref={imgRef}>
                                        {getTableCellData(props.schema, item.attribute, col.dataIndex, isOthersActive, "dot3-icon-align")}
                                    </Button>
                                </Dropdown>
                            </span>
                        ) : (
                            <></>
                        )
                    }

                    if (col.dataIndex === "ActiveUser") {

                        if (typeof item.attribute.ActiveUser !== "undefined") {
                            if (item.attribute.ActiveUser[0].id === "Inactive") {
                                return (
                                    <span>
                                        <Dropdown
                                            menu={{ items: getOnHoverItemList(rowData.key, dispatch, props) }}
                                            onOpenChange={(open) => setOptionHoverIndex(open ? index : null)}
                                        >
                                            <Button className="tbl-active-btn" ref={imgRef}>
                                                {getTableCellData(props.schema, item.attribute, col.dataIndex, rowHovered, "dot3-icon-align")}
                                            </Button>
                                        </Dropdown>
                                    </span>
                                );
                            } else {
                                return (getTableCellData(props.schema, item.attribute, col.dataIndex, rowHovered))
                            }
                        } else {
                            return (getTableCellData(props.schema, item.attribute, col.dataIndex, rowHovered))
                        }
                    }

                    if (col.dataIndex === "oxeactions"){
                        return (
                            <span>
                                <Button className="tbl-active-btn" ref={imgRef}
                                    onClick={()=> props.dirSyncOxeActionHandling(item, rowData)
                                }
                                >
                                    {
                                        getTableCellData(props.schema, item.attribute, col.dataIndex, rowHovered)}
                                </Button>
                            </span>
                        );
                    }

                    // Default case for all other columns
                    return getTableCellData(props.schema, item.attribute, col.dataIndex, rowHovered)
                })(),
            }
        })

        return rowData
    }

    const getDataSource = () => {
        let tempDataSource = []

        props.filteredData?.length && props.filteredData.forEach((item, index) => {
            let rowData = { ...item, key: item.id }
            rowData = generateCustomRowData({ rowData, item, index })
            tempDataSource.push(rowData)
        })

        setDataSource(tempDataSource)
    }

    const handleRowHover = (key) => {
        setHoveredRow(key)
    }

    const handleBulkRowSelection = (rows) => {
        setSelectedRows(rows)
        props.handleBulkSelection(rows)
    }

    return <>
        <UMCTable
            columns={columns}
            dataSource={dataSource}
            rowIndex={optionHoverIndex}
            rowActiveClassName="dd-hover-active"
            rowIdleClassName="dd-hover-idle"
            handleRowHover={handleRowHover}
            handleRowSelect={props.handleRowSelect}
            height={props.height}
            isDynamicAction={props.isDynamicAction}
            fetchData={props.fetchData}
            bulk={props.bulk}
            handleBulkSelection={handleBulkRowSelection}
            selectedRows={selectedRows}
        />
        {isModalVisible && (
            <UMCModal
                title={props.titleRenderer(currRowData)}
                open={isModalVisible}
                handleClose={() => setIsModalVisible(false)}
                width={900}
                closable={props.closable}
                onCancel={handleModalClose}
                footer={
                    <div style={{ textAlign: "center" }}>
                        <UMCButton type="primary" size="middle" onClick={handleModalClose} label={getTranslated(dict, "LABEL_CLOSE")}></UMCButton>
                    </div>
                }
                content={
                    modalData ? (
                        <>
                            <UMCTable
                                columns={Object.keys(modalData[0].attribute).map((key) => ({
                                    title: key.charAt(0).toUpperCase() + key.slice(1),
                                    dataIndex: key,
                                    key: key,
                                    render: (text) => text || "N/A",
                                }))}
                                dataSource={modalData.map(e => e.attribute)}
                                rowKey={(record) => record.index || `${record.attribute}-${record.operation}`}
                                className="modal-table"
                                size="small"
                                height={300}
                            />
                        </>
                    ) : (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                            <span>No data available</span>
                        </div>
                    )
                }

            />

        )}
    </>

}

export default CustomTable